import axios from 'axios';
import maxbo from './maxbo';
import log from './log';
const superoffice = {

    async getCustomer(query) {
        let customer = {};
        
        // Check if URL contains the required parameters
        if (query.cid && query.aid) {
            // Check SuperOffice authorization
            let soauth = '';
            if (query.basic) {
                soauth = 'Basic ' + query.basic;
                log.s('using BASIC authorization for SuperOffice');
            }else if (query.soticket) {
                soauth = 'SOTICKET ' + query.soticket;
                log.s('using SOTICKET authorization for SuperOffice');
            }

            let response = await maxbo.getCustomer(query.cid, query.aid, soauth);
            console.log('response', response.data);
            customer = response.data.customer;
            maxbo.socreds = response.data.creds;

            if (customer.editor.email == 'magnus.ursin@verified.eu') {
                customer.contact.email = 'magnus.ursin+co@verified.eu';
                customer.associate.email = 'magnus.ursin+as@verified.eu';
                customer.editor.email = 'magnus.ursin+ed@verified.eu';
            }

            console.log('customer from SuperOffice', customer);
            //console.log(JSON.stringify(response));

        }else {
            log.w('using SuperOffice TEST data');
            let response = await axios.get('testdata/superoffice1.json');
            customer = response.data.data;
            customer.test = true;
            //console.log('customer from SuperOffice', customer);
            await new Promise(r => setTimeout(r, 100));
        }

        customer.editorIsOwner = customer.editor.email == customer.associate.email;

        return customer;
    },

};
export default superoffice;